import { createFileRoute } from "@tanstack/react-router";
import { LocationIndex } from "@/components/prayer/LocationIndex";

export const Route = createFileRoute("/jadwal-buka-puasa/lokasi")({
  head: () => ({
    meta: [
      { title: "Indeks Lokasi Jadwal Buka Puasa - Semua Kota Indonesia" },
      { name: "description", content: "Daftar lengkap provinsi, kota, dan kecamatan di Indonesia untuk jadwal buka puasa (Maghrib). Pilih lokasi Anda." },
      { property: "og:title", content: "Indeks Lokasi Jadwal Buka Puasa" },
      { property: "og:description", content: "Daftar provinsi, kota & kecamatan untuk jadwal buka puasa." },
      { property: "og:url", content: "https://hari.co.id/jadwal-buka-puasa/lokasi/" },
      { name: "robots", content: "index, follow, max-image-preview:large" },
    ],
    links: [{ rel: "canonical", href: "https://hari.co.id/jadwal-buka-puasa/lokasi/" }],
  }),
  component: () => <LocationIndex variant="buka-puasa" />,
});